import { IconStat } from '~/ui-components';
import { Menu, MenuButton, MenuList, MenuItem, MenuButtonProps } from '@chakra-ui/react';
import { EventBoundary } from '~/ui-components';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Link from 'next/link';

export type IconMenuProps = MenuButtonProps & {
   icon: IconDefinition;
   accessibilityLabel: string;
   menuItems: { text: string; href: string }[];
};

export function IconMenu({
   icon,
   accessibilityLabel,
   menuItems,
   ...menuButtonProps
}: IconMenuProps) {
   return (
      <EventBoundary display="inline-flex" alignItems="center">
         <Menu>
            <MenuButton {...menuButtonProps}>
               <IconStat icon={icon} accessibilityLabel={accessibilityLabel} />
            </MenuButton>
            <MenuList>
               {menuItems.map(menuItem => (
                  <Link key={menuItem.text} href={menuItem.href} passHref legacyBehavior>
                     <MenuItem>{menuItem.text}</MenuItem>
                  </Link>
               ))}
            </MenuList>
         </Menu>
      </EventBoundary>
   );
}
